import { useState } from "react";
import { supabaseAuth } from "./supabaseClient";

const C = { blue:"#2f2aac", green:"#d4fd49", lavender:"#c2c1fa", bg:"#0a0928", card:"#0e0d2e", inner:"#13124a", border:"#1a1850", white:"#ffffff", grey:"#cecece" };

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setLoading(true);
    try {
      const { data, error: err } = await supabaseAuth.auth.signInWithPassword({ email, password });
      if (err) { setError(err.message); return; }
      onLogin(data.session);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{fontFamily:"'Mulish',sans-serif",background:C.bg,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",color:C.white}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700;900&display=swap');
        *{box-sizing:border-box;}
        input:focus{outline:none;border-color:${C.green}!important;}
      `}</style>
      <div style={{width:"340px",background:C.card,border:`1px solid ${C.border}`,borderRadius:"12px",padding:"28px"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"22px"}}>
          <div style={{background:C.green,color:C.bg,fontWeight:900,fontSize:"11px",padding:"4px 9px",borderRadius:"4px",letterSpacing:"0.07em"}}>RANGERS</div>
          <div style={{fontWeight:800,fontSize:"14px"}}>Lead Research Pipeline</div>
        </div>
        <div style={{fontWeight:800,fontSize:"16px",marginBottom:"16px"}}>Sign in</div>
        <form onSubmit={submit}>
          <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email"
            style={{width:"100%",background:C.inner,border:`1px solid ${C.blue}`,borderRadius:"7px",color:C.white,fontFamily:"'Mulish',sans-serif",fontSize:"13px",padding:"10px 14px",marginBottom:"10px"}}/>
          <input type="password" required value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password"
            style={{width:"100%",background:C.inner,border:`1px solid ${C.blue}`,borderRadius:"7px",color:C.white,fontFamily:"'Mulish',sans-serif",fontSize:"13px",padding:"10px 14px",marginBottom:"14px"}}/>
          {error && <div style={{background:"#1e0f0f",border:"1px solid #7a1c1c",borderRadius:"8px",padding:"9px 12px",color:"#ff7070",fontSize:"12px",marginBottom:"12px"}}>⚠️ {error}</div>}
          <button type="submit" disabled={loading} style={{width:"100%",background:loading?C.border:C.blue,color:C.green,border:"none",borderRadius:"7px",fontFamily:"'Mulish',sans-serif",fontWeight:800,fontSize:"13px",padding:"11px",cursor:loading?"not-allowed":"pointer"}}>
            {loading ? "Please wait..." : "Sign in →"}
          </button>
        </form>
        <div style={{textAlign:"center",marginTop:"16px",fontSize:"11px",color:"#555"}}>
          Need access? Contact your admin to have an account created.
        </div>
      </div>
    </div>
  );
}
